import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { isNumber } from "lodash";
import orderService from "src/_services/orderService";

//=========== assign single driver to single order==========
export const assignDriverToOrder = createAsyncThunk(
    'assignOrders/assignDriverToOrder',
    async (payload, { dispatch, rejectWithValue }) => {
        try {
            dispatch(clearAssignOrderState())
            const response = await orderService.assignDriverToOrder(payload);
            return response.data.body;
        } catch (error) {
            return rejectWithValue(error.response?.data);
        }
    }
);
//=========== assign drivers to orders==========
export const assignDriversToOrders = createAsyncThunk(
    'assignOrders/assignDriversToOrders',
    async (payload, { dispatch, rejectWithValue }) => {
        try {
            dispatch(clearAssignOrderState())
            const response = await orderService.assignDriversToOrders(payload);
            return response.data.body;
        } catch (error) {
            return rejectWithValue(error.response?.data);
        }
    }
);
//=========== assign single shipping company to single order==========
export const assignSingleOrderToShippingCompany = createAsyncThunk(
    'assignOrders/assignSingleOrderToShippingCompany',
    async (payload, { dispatch, rejectWithValue }) => {
        try {
            dispatch(clearAssignOrderState())
            const response = await orderService.assignSingleOrderToShippingCompany(payload);
            return  response.data.body;
        } catch (error) {
            return rejectWithValue(error.response?.data);
        }
    }
);
//=========== assign shipping company to orders==========
export const assignShippingCompanyToOrders = createAsyncThunk(
    'assignOrders/assignShippingCompanyToOrders',
    async (payload, { dispatch, rejectWithValue }) => {
        try {
            dispatch(clearAssignOrderState())
            const response = await orderService.assignShippingCompanyToOrders(payload);
            return response.data.body;
        } catch (error) {
            return rejectWithValue(error.response?.data);
        }
    }
);

const slice = createSlice({
    name: "assignOrders",
    initialState: {
        assignOrderPending: false,
        assignOrderError: null,
        assignOrderSuccess: null,
        skippedAssingedOrder: 0,
        ordersIssues: [],
    },
    reducers: {
        clearAssignOrderState: (state) => {
            //state.assignOrderPending = false
            state.assignOrderError = null
            state.assignOrderSuccess = null
            state.skippedAssingedOrder = 0
            state.ordersIssues = []
        }
    },
    extraReducers: {
        //===========Assign single order to single driver===================
        [assignDriverToOrder.pending]: (state) => {
            state.assignOrderPending = true
        },
        [assignDriverToOrder.fulfilled]: (state, { payload }) => {
            state.assignOrderPending = false
            state.assignOrderSuccess = true
        },
        [assignDriverToOrder.rejected]: (state, action) => {
            state.assignOrderPending = false
            state.assignOrderError = action.payload ? action.payload.message : "Something went wrong please try again";
        },
        //===========Assign orders to drivers===================
        [assignDriversToOrders.pending]: (state) => {
            state.assignOrderPending = true
        },
        [assignDriversToOrders.fulfilled]: (state, { payload }) => {
            state.assignOrderPending = false
            if (isNumber(payload.skip_orders_count) && payload.skip_orders_count > 0) {
                state.skippedAssingedOrder = payload.skip_orders_count
                state.ordersIssues = payload.errors
              //  state.assignOrderError = "assignDriverFailed"
            } else {
                state.assignOrderSuccess = true
            }
        },
        [assignDriversToOrders.rejected]: (state, action) => {
            state.assignOrderPending = false
            state.assignOrderError = action.payload ? action.payload.message : "Something went wrong please try again";
        },
        //=========Assign to shipping company-==============
        [assignSingleOrderToShippingCompany.pending]: (state) => {
            state.assignOrderPending = true
        },
        [assignSingleOrderToShippingCompany.fulfilled]: (state, { payload }) => {
            state.assignOrderPending = false
            state.assignOrderSuccess = true
        },
        [assignSingleOrderToShippingCompany.rejected]: (state, action) => {
            state.assignOrderPending = false
            state.assignOrderError = action.payload ? action.payload.message : "Something went wrong please try again";
        },
        //=========Assign  shipping company to muliple orders==============
        [assignShippingCompanyToOrders.pending]: (state) => {
            state.assignOrderPending = true
        },
        [assignShippingCompanyToOrders.fulfilled]: (state, { payload }) => {
            state.assignOrderPending = false
            if (isNumber(payload?.skip_orders_count) && payload.skip_orders_count > 0) {
                state.skippedAssingedOrder = payload.skip_orders_count
                state.ordersIssues = payload.errors
                // if (payload.priceType === SUBMERCHANT_PRICING_METHODS.kg) {
                //     state.assignOrderError = "cannotAssignShippingCompanyForWeight"
                // } else if (payload.priceType === SUBMERCHANT_PRICING_METHODS.piece) {
                //     state.assignOrderError = "cannotAssignShippingCompanyForWarehouse"
                // } else {
                //     state.assignOrderError = "Something went wrong please try again"
                // }

            } else {
                state.assignOrderSuccess = true
            }
        },
        [assignShippingCompanyToOrders.rejected]: (state, action) => {
            state.assignOrderPending = false
            state.assignOrderError = action.payload ? action.payload.message : "Something went wrong please try again";
        },
    },

});


export const {
    clearAssignOrderState
} = slice.actions;



export default slice.reducer;
